import { useState, useEffect } from 'react';
import { Globals } from 'utils';

type FallbackImageProps = {
  src?: string | null
  placeholder: string
  className: string
  placeholderClassName: string
  alt?: string
}

const FallbackImage = ({ src, placeholder, className, placeholderClassName, alt = 'Foto' }: FallbackImageProps) => {
  const parsedUrl = src || '';
  const isExternal = String(parsedUrl).startsWith('http');
  const isBlob = String(parsedUrl).startsWith('blob');
  const uri = isExternal ? parsedUrl : (isBlob ? parsedUrl : Globals.fromPhotos(parsedUrl));
  const [isPdf, setIsPdf] = useState(false);
  const [isBroken, setIsBroken] = useState(false);

  useEffect(() => {
      if (uri && uri.startsWith('blob:')) {
          fetch(uri)
              .then(res => {
                  const type = res.headers.get('content-type');
                  setIsPdf(type === 'application/pdf');
              })
              .catch(() => setIsPdf(false));
      }
      else if (uri.endsWith('.pdf')) {
        setIsPdf(true);
      }
  }, [uri]);

  if (!parsedUrl || isBroken) return (
    <img src={placeholder} className={placeholderClassName} alt={alt} />
  );

  return (
    <>
      {
        isPdf ? (
          <div style={{
            width: '100%',
            height: '350px',
            overflow: 'hidden',
            border: '1px solid #ccc'
          }}>
            <iframe src={ uri } style={{ border: 'none', width: '100%', height: '406px', marginTop: '-56px' }} />
          </div>
        ) : (
          <img src={uri} className={className} onError={() => setIsBroken(true)} alt={alt} />
        )
      }
    </>
  );
};

export default FallbackImage;
